export default IconCsv => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-csv" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-2a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1" />
  <path d="M17 8l2 8l2 -8" />
  <path d="M7 10a2 2 0 1 0 -4 0v4a2 2 0 1 0 4 0" />
</svg>`;